module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//pet-box_2.png?v=887acdc6";